import { styled } from 'goober';

export const DataTableWrapper = styled('div')`
    overflow: auto;
    max-height: 400px;
    border: 1px solid ${(props) => props.theme.colors.neutral.w200};
    border-radius: 6px;
`;

export const StyledTable = styled('table')`
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    table-layout: auto;
`;

export const DataTh = styled('th')`
    position: sticky;
    top: 0;
    background: ${(props) => props.theme.colors.neutral.w100};
    padding: 6px 10px;
    text-align: left;
    font-weight: 600;
    white-space: nowrap;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.w200};
    z-index: 1;
`;

export const DataTd = styled('td')`
    padding: 4px 10px;
    white-space: nowrap;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.w50};
    font-family: 'SF Mono', 'Fira Code', 'Fira Mono', Menlo, monospace;
`;

export const RowNumberTh = styled('th')`
    position: sticky;
    top: 0;
    background: ${(props) => props.theme.colors.neutral.w100};
    padding: 6px 8px;
    text-align: right;
    font-weight: 600;
    color: ${(props) => props.theme.colors.neutral.w400};
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.w200};
    width: 40px;
    min-width: 40px;
    z-index: 1;
`;

export const RowNumberTd = styled('td')`
    padding: 4px 8px;
    text-align: right;
    color: ${(props) => props.theme.colors.neutral.w400};
    border-bottom: 1px solid ${(props) => props.theme.colors.neutral.w50};
    width: 40px;
    min-width: 40px;
    font-size: 11px;
`;

export const ShowMoreButton = styled('button')`
    background: none;
    border: 1px solid ${(props) => props.theme.colors.neutral.w200};
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 12px;
    color: ${(props) => props.theme.colors.neutral.w600};
    cursor: pointer;
    align-self: center;
    &:hover {
        background: ${(props) => props.theme.colors.neutral.w50};
    }
`;
